import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { BlockClientSearchResultsAllComponent } from '@core-app/blocks/block-search-results-all/block-search-results-all.component';
import { APP_CONFIG as LOCAL_APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-client-search-results',
    templateUrl: './search-results.component.html',
    standalone: false,
})
export class SearchResultsComponent extends BlockClientSearchResultsAllComponent {
    @Input() modalRef?: any;
    @Output() closeHamburgerNav = new EventEmitter<boolean>();

    resultsSlice: number = 6;
    activeResult: number = -1;

    searchUrlWithZone() {
        return '/' + this.currentZone + '/search';
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (!this.isTouchDevice()) {
            switch (event.code) {
                case 'ArrowDown':
                    this.activeResult = Math.min(
                        this.activeResult + 1,
                        this.results.slice(0, this.resultsSlice).length - 1,
                    );
                    break;
                case 'ArrowUp':
                    this.activeResult = Math.max(0, this.activeResult - 1);
                    break;
                case 'Enter':
                    if (this.results[this.activeResult]) {
                        this.navigateToSearchResultsLink(this.results[this.activeResult]);
                        event.preventDefault();
                    }
                    break;
            }
        }
    }

    closeModal(): void {
        this.closeHamburgerNav.emit(false);
        this.modalRef.hide();
    }

    override navigateToSearchResultsLink(result: any) {
        const articlesParentRoute = (LOCAL_APP_CONFIG as any).articlesParentRoute || 'articles';

        if (!result.isDownload) {
            if (result.type === 'articles') {
                this.router.navigate([this.parentUrl(result), articlesParentRoute, result.url]);
            } else {
                // Add the parent URL to the result URL
                this.router.navigate([this.parentUrl(result), result.url]);
            }
        } else {
            this.downloadItem(result.token, result.name);
        }
        this.closeModal();
    }

    showNoResults(): boolean {
        return !this.hasResults() && this.search.isActive() && !this.isLoading;
    }

    isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || (navigator as any)['msMaxTouchPoints'] > 0;
    }
}
